import { useState } from "react";
import { EffectFade, Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { socialMediaIcons } from "../../data/socials";
import trainer from "../../assets/img/developer.jpg";
import aiCourse from "../../assets/img/images (1).jpeg";
import machineLearningCourse from "../../assets/img/Generative-AI-course.jpg";
import deepLearningCourse from "../../assets/img/AI-Training.jpg";
import ethicsCourse from "../../assets/img/download (2).jpeg";

const imageUrlsThumb = [
  aiCourse,
  machineLearningCourse,
  deepLearningCourse,
  ethicsCourse
];
const imageUrls = [
  trainer,
  trainer,
  trainer,
  trainer,
];
const swiperThumbOptions = {
  slidesPerView: 3,
  spaceBetween: 11,
  loop: true,
  modules: [Thumbs],
  slideToClickedSlide: true,
};
const swiperOptions2 = {
  slidesPerView: 1,
  loop: true,
  effect: "fade",
  modules: [EffectFade, Thumbs],
  loopedslides: 4,
};

export default function UserProfile() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const userData = {
    id: 1,
    src: "/assets/images/box-item/image-12.jpg",
    title: "Yessin Rebhi",
    price: "Professional AI Trainer",
    delay: "0s",
  };

  return (
    <div className="single-product pt-130">
      <div className="section-container">
        <div className="row justify-between">
          <div className="col-md-6">
            <div className="widget-gallery-slider gallery-style-1">
              <div className="gallery">
                <Swiper
                  watchSlidesProgress
                  onSwiper={setThumbsSwiper}
                  {...swiperThumbOptions}
                  className="swiper-item gallery-thumbs"
                >
                  {imageUrlsThumb.map((elm, i) => (
                    <SwiperSlide key={i} className="swiper-slide">
                      <img src={elm} width={630} height={515} alt="AI Course" />
                    </SwiperSlide>
                  ))}
                </Swiper>
                <Swiper
                  {...swiperOptions2}
                  thumbs={thumbsSwiper ? { swiper: thumbsSwiper } : null}
                  className="swiper-item gallery-slider relative"
                >
                  {imageUrls.map((elm, i) => (
                    <SwiperSlide key={i} className="swiper-slide">
                      <img src={elm} alt="Trainer" width={630} height={515} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="wg-single-detail">
              <div className="sub-title">
                Trainer
                <div className="rating">
                  <i className="icon-star" />
                  <i className="icon-star" />
                  <i className="icon-star" />
                  <i className="icon-star" />
                  <i className="icon-star" />
                </div>
              </div>
              <div className="title">{userData.title}</div>
              <div className="price">{userData.price}</div>
              <p>
                Yessin Rebhi is a leading AI expert with over 8 years of experience in artificial intelligence and machine learning. Known for her ability to simplify complex AI concepts, Yessin is passionate about making AI accessible to all. Her hands-on training sessions help learners apply AI techniques to real-world problems, ensuring practical experience and a deep understanding of AI technologies.
              </p>
              <div className="button-group flex gap20">
                <a href="#" className="tf-button type-1 h45">
                  <span>Browse AI Courses</span>
                  <i className="icon-arrow-right2" />
                </a>
              </div>
              <div className="more-infor">
                <div className="item">
                  <h6>Categories :</h6>
                  <div className="text">
                    <span className="tf-color">AI, </span>
                    Machine Learning, Deep Learning
                  </div>
                </div>
                <div className="item">
                  <h6>Tags :</h6>
                  <div className="text">
                    <span className="tf-color">AI, </span>
                    Data Science, Automation
                  </div>
                </div>
                <div className="item">
                  <h6>Share :</h6>
                  <div>
                    <ul className="wg-social style-2">
                      {socialMediaIcons.map((icon, index) => (
                        <li key={index}>
                          <a href={icon.href} className={icon.className} />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
